/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgWordLogoColor = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M15 4V1.875A.878.878 0 0 0 14.125 1h-9.25A.875.875 0 0 0 4 1.875V4h11Z",
        fill: "#41A5EE"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15 4H4v4h11V4Z",
        fill: "#2B7CD3"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15 8H4v4h11V8Z",
        fill: "#185ABD"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4 12v2.125a.878.878 0 0 0 .875.875h9.25a.875.875 0 0 0 .875-.875V12H4Z",
        fill: "#103F91"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: 0.5,
        d: "M9.2 5H4v8h5.2a.8.8 0 0 0 .8-.8V5.8a.8.8 0 0 0-.8-.8Z",
        fill: "#000"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.2 4H1.8a.8.8 0 0 0-.8.8v6.4a.8.8 0 0 0 .8.8h6.4a.8.8 0 0 0 .8-.8V4.8a.8.8 0 0 0-.8-.8Z",
        fill: "#185ABD"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.682 9.232c.013.114.022.213.027.3h.015a5.176 5.176 0 0 1 .089-.579l.73-3.353h.945l.756 3.3c.046.205.08.413.1.623h.012c.014-.201.04-.402.079-.6l.6-3.323H7.9l-1.064 4.8h-1L5.11 7.22a8.748 8.748 0 0 1-.071-.358c-.027-.147-.039-.254-.048-.321h-.013a7.632 7.632 0 0 1-.049.348 8.515 8.515 0 0 1-.058.341l-.677 3.17H3.173L2.105 5.6h.876l.658 3.357c.015.07.029.161.043.275Z",
        fill: "#fff"
    }));
export default SvgWordLogoColor;
